import React, { createContext, useState } from 'react';
import { GivingStrategy, WorkflowDTO } from '../api/useCharitableGivingQuery';
import { Step, STEPS_DICT } from '../CharitableGiving.meta';

interface Context {
  workflow: WorkflowDTO;
  setWorkflow: React.Dispatch<React.SetStateAction<WorkflowDTO>>;
  step: Step;
  setStep: React.Dispatch<React.SetStateAction<Step>>;
  steps: Step[];
  setSteps: React.Dispatch<React.SetStateAction<Step[]>>;
  onPreviousStage(): void;
}

export const CharitableGivingContext = createContext<Context | undefined>(undefined);

interface Props {
  data: WorkflowDTO;
  onPreviousStage(): void;
  children: React.ReactNode;
}

export const CharitableGivingProvider = ({ children, data, onPreviousStage }: Props) => {
  const [workflow, setWorkflow] = useState(data);

  const [steps, setSteps] = useState(
    STEPS_DICT[workflow.data.givingStrategy ?? GivingStrategy.DonationToDAF],
  );

  const [step, setStep] = useState(steps[0]);

  return (
    <CharitableGivingContext.Provider
      value={{
        workflow,
        setWorkflow,
        step,
        setStep,
        steps,
        setSteps,
        onPreviousStage,
      }}
    >
      {children}
    </CharitableGivingContext.Provider>
  );
};
